import React from 'react';

import { ReactComponent } from '../../assets/svg/filter_center_focus.svg';


export default () => <ReactComponent />;
